import React, { useState } from 'react';
import Collection from '../Collection Limit/Collection';
import PendingLimit from '../PendingLimit/PendingLimit';
import Transfer from '../TransferLimit/Transfer';
import styles from './LimitTab.module.scss';

function LimitTab() {
	interface dataTypes {
		id: Number;
		menu: String;
	}
	const [selectedNav, setSelectedNav] = useState<Number>(1);
	const dataRef: dataTypes[] = [
		{
			id: 1,
			menu: 'Collection limits',
		},
		{
			id: 2,
			menu: 'Payout limits',
		},
		{
			id: 3,
			menu: 'Pending limits',
		},
	];
	return (
		<>
			<div className={styles.tabContainer}>
				{dataRef.map(({ id, menu }: dataTypes, i) => (
					<div
						key={i}
						onClick={() => {
							setSelectedNav(id);
						}}
						className={
							selectedNav === id ? styles.activeMenuItem : styles.subMenuItem
						}>
						{selectedNav === id ? (
							<div className={styles.activeItemColor}>{menu}</div>
						) : (
							<div style={{ color: 'rgba(10, 9, 3, 0.6)' }}>{menu}</div>
						)}
					</div>
				))}
			</div>

			<div>
				{selectedNav === 1 ? (
					<Collection />
				) : selectedNav === 2 ? (
					<Transfer />
				) : selectedNav === 3 ? (
					<PendingLimit title='limit' />
				) : (
					''
				)}
			</div>
		</>
	);
}

export default LimitTab;
